import React from "react";
import WarningIcon from "@material-ui/icons/Warning";
import RefreshIcon from "@material-ui/icons/Refresh";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography, Paper, Box } from "@material-ui/core";
import logo from "assets/images/global-logo.png";

const ErrorModal = ({ allowedTabs, classes }) => {
  return (
    <>
      <img alt='amherstLogo' src={logo} className={classes.logo} />
      <Grid container justifyContent="center" alignItems="center" direction="column" className={classes.matchHeight}>
        <Paper elevation={1} className={classes.paper}>
          <Typography variant="h4" gutterBottom className={classes.title}>
            <WarningIcon color="primary" className={classes.icon} />
            Window limit reached
          </Typography>
          <Typography variant="subtitle1" gutterBottom className={classes.subtitle}>
            The number of connections to ReVUe is limited to {allowedTabs}. Close other ReVUe windows and try again.
          </Typography>
          <Box textAlign="right">
            <Button variant="contained" color="primary" startIcon={<RefreshIcon />} className={classes.button} onClick={() => window.location.reload()}>
              Try again
            </Button>
          </Box>
        </Paper>
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  button: {
    backgroundColor: "#004990",
    color: '#fff',
    "&:hover": {
      backgroundColor: 'rgb(0, 51, 100)'
    }
  },
  logo: {
    position: "absolute",
    height: 48,
  },
  matchHeight: {
    height: "100%",
  },
  paper: {
    padding: theme.spacing(7),
    maxWidth: theme.spacing(50),
  },
  icon: {
    fontSize: 50,
    marginRight: 15,
    color: "#ffca1c"
  },
  title: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  subtitle: {
    opacity: 0.5,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  btnOffset: {
    marginRight: theme.spacing(1),
  },
});

export default withStyles(styles)(ErrorModal);